import { Text } from 'preact-i18n';

const dateDisplayOptions = { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' };

const MCPApiKey = ({ children, ...props }) => {
  let revokeMCPApiKey = e => {
    e.preventDefault();
    props.revokeMCPApiKey(props.apiKey.id || props.apiKey.session_id, props.index);
  };

  let language = props.user && props.user.language ? props.user.language : 'en';

  let createdAt = new Date(props.apiKey.created_at).toLocaleDateString(language, dateDisplayOptions);

  return (
    <tr>
      <td>
        <div style="max-width: 400px; overflow: hidden">{props.apiKey.useragent}</div>
        {props.apiKey.api_key && (
          <div class="small">
            <Text id="integration.mcp.keyNameLabel" /> {props.apiKey.api_key}
          </div>
        )}
        {props.apiKey.created_at && (
          <div class="small text-muted">
            <Text id="integration.mcp.registeredLabel" /> {createdAt}
          </div>
        )}
      </td>
      <td>
        <i style={{ cursor: 'pointer' }} onClick={revokeMCPApiKey} class="fe fe-trash-2" />
      </td>
    </tr>
  );
};

export default MCPApiKey;
